import { render, staticRenderFns } from "./ShCategoryQuickSlider.vue?vue&type=template&id=162b9a8a&scoped=true&"
import script from "./ShCategoryQuickSlider.vue?vue&type=script&lang=js&"
export * from "./ShCategoryQuickSlider.vue?vue&type=script&lang=js&"
import style0 from "./ShCategoryQuickSlider.vue?vue&type=style&index=0&id=162b9a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162b9a8a",
  null
  
)

export default component.exports